export enum DateOptions {
  TODAY = "TOD",
  TOMORROW = "TMR",
  ALL_DAY = "ALL",
}
